/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A schema for a linked file value in a Credential claim.
 */
export interface CredentialClaimLinkedFileValue {
    /** The multibase digest of the linked file. */
    digestMultibase?: string;
    /** The ID of the linked file. */
    id: string;
}
